var _defs, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgScreenshot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.563,
    height: 18.527,
    viewBox: "0 0 18.563 18.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#20bead;stroke:#20bead;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.117,5.792a.706.706,0,1,0,1.411,0V4.028H5.257a.706.706,0,1,0,0-1.411H3.528V1.206a.706.706,0,0,0-1.411,0V2.617H.706a.706.706,0,0,0,0,1.411H2.117Z",
    transform: "translate(0 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M412.706,210.5a.706.706,0,0,0-.706.706v1.835a.706.706,0,1,0,1.411,0v-1.835A.706.706,0,0,0,412.706,210.5Z",
    transform: "translate(-397.465 -203.092)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M342.706,61.911h.353a1.413,1.413,0,0,1,1.411,1.411v.353a.706.706,0,0,0,1.411,0v-.353a2.825,2.825,0,0,0-2.822-2.822h-.353a.706.706,0,0,0,0,1.411Z",
    transform: "translate(-329.935 -58.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M60.706,210.5a.706.706,0,0,0-.706.706v1.835a.706.706,0,0,0,1.411,0v-1.835A.706.706,0,0,0,60.706,210.5Z",
    transform: "translate(-57.883 -203.092)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M63.175,344.934h-.353a1.413,1.413,0,0,1-1.411-1.411v-.318a.706.706,0,0,0-1.411,0v.318a2.825,2.825,0,0,0,2.822,2.822h.353a.706.706,0,0,0,0-1.411Z",
    transform: "translate(-57.883 -330.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M347.292,344.934h-1.411v-1.729a.706.706,0,0,0-1.411,0v1.729h-1.764a.706.706,0,0,0,0,1.411h1.764v1.411a.706.706,0,0,0,1.411,0v-1.411h1.411a.706.706,0,0,0,0-1.411Z",
    transform: "translate(-329.935 -330.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M212.54,60.5h-1.834a.706.706,0,0,0,0,1.411h1.834a.706.706,0,1,0,0-1.411Z",
    transform: "translate(-202.592 -58.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M212.54,411.5h-1.834a.706.706,0,1,0,0,1.411h1.834a.706.706,0,1,0,0-1.411Z",
    transform: "translate(-202.592 -397.001)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshot);
export default __webpack_public_path__ + "static/media/screenshot.ae28f7d6.svg";
export { ForwardRef as ReactComponent };